var errorMessage = {
    // TODO: Put these config objects somewhere better
     pendingPaymentAlertConfig : {
        alertType:"info",
        title: "",
        message: "Until any pending payments are processed, we can't accept additional payments or help you set up automatic payments.",
        suppressIcon: false
    },
    successfulPaymentAlertConfig : {
        alertType:"success",
        title: "",
        message: "Payment submitted.",
        suppressIcon: false
    },
    achRenewalAlertConfig : {
        alertType:"warn",
        title: "",
        message: "Your automatic payments have been suspended. You must authorize CVS/specialty to continue to withdraw on your behalf.",
        suppressIcon: false
    },
    cardExpiredAlertConfig : {
        alertType:"warn",
        title: "",
        message: "One of your saved cards has expired. Edit card to update it.",
        suppressIcon: false
    },
    errorMessageGeneral : {
        alertType:"error",
        title: "System Error",
        message: "We're sorry. There was an error processing your request. Please try again, or connect to our technical support team from our ",
        suppressIcon: false,
        contactlink: "Contact Us"
    }
};